export enum QuantSpaceUniverseTypeConstants {
  QIS = 'QIS',
  FUND = 'FUND',
  HEDGE_FUND = 'HEDGE_FUND',
}
